import { createContext } from 'react';

export const MapContext = new createContext();
MapContext.displayName = 'MapContext';
